import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import ProjectWritingUser from './components/ProjectWriting/ProjectWritingUser'; // adjust path as needed

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <BrowserRouter>
//     <Routes>
//       <Route
//         path="/"
//         element={
//           <ProjectWritingUser
//             onSubmit={(...args) => {
//               console.log("Submitted!", args);
//             }}
//           />
//         }
//       />
//     </Routes>
//   </BrowserRouter>
// );
